module.exports = __webpack_public_path__ + "img/066.7ccaa2e3.png";